import { MockFactory } from '@tino-frontend/mocks'
import { ContractStatusResponse } from '@types'

export const contractCollectingAPIMock =
  new MockFactory<ContractStatusResponse>({
    is_collecting: true,
    percentage: 70.5,
  })
